import { FaSearch } from "react-icons/fa";

export default function SearchInput({
  placeholder,
  value,
  onChange,
}) {
  return (
    <div className="relative mb-6">

      <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />

      <input
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="
          w-full
          rounded-xl
          border
          border-green-500/20
          bg-gray-900/80
          py-3
          pl-12
          pr-4
          text-white
          focus:ring-2
          focus:ring-green-400
          outline-none
        "
      />

    </div>
  );
}